import {SetGetPresentList} from './thunk/setGetPresentList';
import {SetPostPresentCancel} from './thunk/setPostPresentCancel';
import {SetPostPresentSuccess} from './thunk/setPostPresentSuccess';

export const Thunks = {
    SetGetPresentList,
    SetPostPresentCancel,
    SetPostPresentSuccess
}